import React from 'react'
import style from './MasProductos.module.css'

import imagen1 from '../../../../utils/images/box-1.png'
import imagen2 from '../../../../utils/images/box-2.png'
import CardProductos from '../../../generales/CardProductos'

const MasProductos = ({ t }) => {

  return (
    <div className={style.container}>
      <p className={style.titulo}>{t('Products.SupervisionAndControlSystem.More-products.title')}</p>
      <div className={style.productos}>
        <CardProductos
          imagen={imagen1}
          link={"/productos/business-solution"}
          title={"HomePage.Products.business-solution"}
          text={"HomePage.Products.description-of-business-solution"}
        />
        <CardProductos
          imagen={imagen2}
          link={"/productos/evo-scada-server"}
          title={"HomePage.Products.evo-scada-server"}
          text={"HomePage.Products.description-of-evo-scada-server"}
        />
      </div>
    </div>
  )
}

export default MasProductos